/*eslint-disable*/
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { toPng } from 'html-to-image';
import { setErrorNotification } from '../../../../redux/slices/NotificationSlice';
import ModalBox from '../../../../shared/component/ModalBox';
import TemplateContentUpload from '../TemplateContentUpload';
import HtmlHeader from '../HtmlHeader';
import utils from '../templateFunctions';
import { createOrUpdateTemplate } from '../../../../redux/slices/TemplateSlice';
import FileFormat from '../FileFormat';
import PopupBox from '../ContentUploadConfirmation';

function HtmlTemplateTwentyTwo({ templateData }) {
  const [data, setData] = useState([]);
  const [notification, setNotification] = useState(false);
  const [
    openContentUploadConfirmation,
    setOpenContentUploadConfirmation,
  ] = useState(false);
  const [base64, setBase64] = useState('');
  const [htmlContent, setHtmlContent] = useState('');
  const [disable, setDisable] = useState(true);
  const [modalView, setModalView] = useState({ content: '', title: '' });
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const htmlRef = useRef(null);
  const cssStyles = `
body {
    margin: 0;
    padding: 0;
}
@font-face {
 font-family: "Urbanist";
 src: url(../../../assets/fonts/urbanist/Urbanist-Bold.ttf) format("truetype");
 font-weight: 700;
}

@font-face {
 font-family: "Urbanist";
 src: url(../../../assets/fonts/urbanist/Urbanist-Medium.ttf) format("truetype");
 font-weight: 500;
}

@font-face {
 font-family: "Urbanist";
 src: url(../../../assets/fonts/urbanist/Urbanist-Regular.ttf) format("truetype");
 font-weight: 400;
}

@font-face {
 font-family: "Great Vibes";
 src: url(../../../assets/fonts/greatVibes/GreatVibes-Regular.ttf) format("truetype");
 font-weight: 500;
}

.template-container-22 {
 width: 100%;
 height: 100vh;
 box-sizing: border-box;
 padding: 5px;
}

.template-container-22 .main-container .continer22 {
 border: 1px dashed rgba(39, 80, 124, 1);
 margin: 48px;
 padding: 25px 20px;
 display: flex;
 justify-content: center;
 align-items: center;
}

.template-container-22 .main-container .left-top-image {
 position: absolute;
 top: 160px;
 left: 80px;
 width: 150px;
 display: flex;
 flex-direction: row;
 justify-content: center;
 align-items: center;
 gap: 5px;
}

.template-container-22 .main-container .left-top-image img {
 width: 30px;
 height: 30px;
}

.template-container-22 .main-container .left-top-image .company_name {
 font-weight: bold;
 font-size: 20px;
 color: rgba(255, 255, 255, 1);
}

.template-container-22 .main-container .right-top-image {
 position: absolute;
 top: 160px;
 right: 75px;
 width: 120px;
}

.template-container-22 .main-container .right-top-image .dots {
 display: grid;
 grid-template-columns: repeat(2, 12px);
 grid-gap: 20px;
}

.template-container-22 .main-container .right-top-image .dot {
 width: 5px;
 height: 5px;
 background-color: white;
 border-radius: 50%;
}

.template-container-22 .main-container .content {
 display: flex;
 flex-direction: column;
 align-items: center;
 gap: 20px;
}

.template-container-22 .main-container .content .circle_content {
 position: absolute;
 transform: rotate(34.85deg);
 left: 55%;
 top: 13%;
}

.template-container-22 .main-container .content .circle_content .circle {
 width: 137px;
 height: 132px;
 border-radius: 50%;
 background-image: repeating-linear-gradient(
   135deg,
   rgba(79, 144, 205, 1) 0px,
   rgba(79, 144, 205, 1) 1px,
   transparent 2px,
   transparent 10px
 );
 background-color: transparent;
 filter:none;
}

.template-container-22 .main-container .content .profile {
 display: flex;
 align-items: flex-end;
 flex-direction: row;
 gap: 30px;
}

.template-container-22 .main-container .content .profile .personal-image {
 width: 197px;
 height: 254px;
 background-color: rgba(255, 255, 255, 1);
 padding: 5px;
 border-radius: 7px;
 border: 7px solid rgba(255, 255, 255, 1);
 margin-top: 76px;
 position: relative;
}

.template-container-22 .main-container .content .profile .personal-image img {
 width: 100%;
 height: 90%;
}

.template-container-22 .main-container .content .profile .personal-image .persone-name {
 text-align: center;
 display: block;
 color: rgba(12, 55, 98, 1);
 font-size: 15px;
 font-weight: 800;
 font-family: "Urbanist";
 margin-top: 9px;
}

.template-container-22 .main-container .content .profile .sceond-small-circle {
 transform: rotate(60deg);
 margin-bottom: 80px;
 margin-right: 20px;
}

.template-container-22 .main-container .content .profile .sceond-small-circle .small_circle {
 width: 32px;
 height: 30px;
 border-radius: 50%;
 background-image: repeating-linear-gradient(
   135deg,
   rgba(79, 144, 205, 1) 0px,
   rgba(79, 144, 205, 1) 1px,
   transparent 1px,
   transparent 5px
 );
 background-color: transparent;
 filter:none;
}

.template-container-22 .main-container .content .content-text {
 display: flex;
 flex-direction: column;
 align-items: center;
 gap: 20px;
}

.template-container-22 .main-container .content .content-text .name-box {
 padding: 7px 0px;
 width: 42%;
 background-color: #001c3c;
 border-radius: 20px;
}

.template-container-22 .main-container .content .anniversary {
 margin-top: 40px;
 display: flex;
 align-items: center;
 flex-direction: column;
 justify-content: center;
}

.template-container-22 .main-container .content .anniversary .content {
 display: flex;
 align-items: flex-end;
 flex-direction: row;
 gap: 15px;
}

.template-container-22 .main-container .content .anniversary .content .number {
 font-size: 48px;
 font-weight: 700;
 color: #00cfff;
}

.template-container-22 .main-container .content .anniversary .content .number sup {
 font-size: 16px;
 color: rgba(255, 255, 255, 1);
}

.template-container-22 .main-container .content .anniversary .content .work {
 font-size: 32px;
 font-weight: 400;
 color: rgba(255, 255, 255, 1);
}

.template-container-22 .main-container .content .anniversary .title {
 font-family: "Great Vibes", cursive;
 font-size: 64px;
 font-weight: 700;
 margin-top: 10px;
 color: rgba(255, 255, 255, 1);
 letter-spacing: 7px;
}

.template-container-22 .main-container .content .content-description {
 margin-top: 10px;
 width: 60%;
 font-size: 20px;
 font-weight: 400;
 text-align: center;
 line-height: 40px;
 color: rgba(255, 255, 255, 1);
}

.template-container-22 .main-container .left-bottom-image {
 position: absolute;
 bottom: 230px;
 left: 120px;
 width: 120px;
}

.template-container-22 .main-container .left-bottom-image .dots {
 display: grid;
 grid-template-columns: repeat(2, 12px);
 grid-gap: 20px;
}

.template-container-22 .main-container .left-bottom-image .dot {
 width: 5px;
 height: 5px;
 background-color: white;
 border-radius: 50%;
}

.template-container-22 .main-container .right-bottom-image {
 position: absolute;
 bottom: 0;
 right: 0;
 width: 10vw;
}

.template-container-22 .main-container .right-bottom-image img {
 width: 100%;
 height: 100%;
}

/* Responsive */
@media screen and (max-width: 998px) {
 .template-container-22 .main-container .left-top-image {
   top: 0;
   left: 0;
   width: 30vw;
 }
 .template-container-22 .main-container .right-top-image {
   top: 0;
   right: 0;
   width: 30vw;
 }
}

  `;

  const convertImage = async (url) => {
    await utils
      .convertSignedUrl(url)
      .then((response) => {
        setDisable(false);
        dispatch(createOrUpdateTemplate(response));
      })
      .catch((error) => {
        setDisable(false);
        dispatch(setErrorNotification(error?.response?.data));
      });
  };

  const convertBase64 = async () => {
    try {
      // Convert to base64
      const dataUrl = await toPng(htmlRef.current, { cacheBust: true });
      setBase64(dataUrl); // Set the base64 data
      convertImage(dataUrl); // Your function to handle the base64 data
    } catch (error) {
      dispatch(setErrorNotification(error?.response?.data));
    }
  };

  const convertHtml = () => {
    if (htmlRef.current) {
      const content = htmlRef.current.outerHTML;
      const fullHtml = `
        <html>
          <head>
              <link rel="preconnect" href="https://fonts.googleapis.com" />
              <link rel="preconnect" href="https://fonts.gstatic.com" />
              <link 
              href="https://fonts.googleapis.com/css2?family=Great+Vibes&family=Urbanist:wght@100..900&display=swap" 
              rel="stylesheet" />           
              <style>${cssStyles}</style>
          </head>
          <body>${content}</body>
        </html>
      `;
      setHtmlContent(fullHtml); // Set the HTML content as a string
    }
  };

  useEffect(() => {
    utils?.initializer(templateData).then((res) => setData(res));
    utils?.reload();
  }, [templateData]);

  /* useEffect runs convertBase64 after data is updated */
  useEffect(() => {
    if (data) {
      setTimeout(() => {
        convertBase64();
      }, 1000);
      convertHtml();
    }
  }, [data]);

  const handleFileType = (fileType) => {
    setModalView({
      title: 'content',
      content: (
        <TemplateContentUpload
          base64={base64}
          setNotification={setNotification}
          fileType={fileType}
          htmlContent={htmlContent}
        />
      ),
    });
  };

  const onClickContentUpload = () => {
    setNotification(true);
    setModalView({
      title: t('fileFormat'),
      content: (
        <FileFormat
          setNotification={setNotification}
          handleFileType={handleFileType}
          setOpenContentUploadConfirmation={setOpenContentUploadConfirmation}
          data={data}
        />
      ),
    });
  };
  const contentDetails = data?.[0]?.template_contents?.items?.[0]?.details;
  const styles = data?.[0]?.styles?.details;
  const backgroundColor = data?.[0]?.styles?.background;
  const backgroundImage = data?.[0]?.template_backgroundImage_url;
 
  return (
    <div>
      <HtmlHeader
        htmlData={data}
        disable={disable}
        click={onClickContentUpload}
      />

      <ModalBox
        status={notification}
        closeModal={setNotification}
        modalView={modalView}
      />
      <ModalBox
        status={openContentUploadConfirmation}
        closeModal={setOpenContentUploadConfirmation}
        modalView={{
          title: 'Confirmation',
          content: (
            <PopupBox
              setOpenContentUploadConfirmation={
                setOpenContentUploadConfirmation
              }
              setNotification={setNotification}
            />
          ),
        }}
      />
      <div className="header-height" />
      <div
        ref={htmlRef}
        className="template-container-22"
        style={{ backgroundColor: backgroundColor }}
      >
        <div className="main-container">
          <div className="continer22">
            <div className="left-top-image">
              <img
                src={backgroundImage?.[0]}
                alt="logo"
              />
              <span className="company_name"
                style={{
                  color: styles?.[1]?.color,
                  fontSize: styles?.[1]?.fontSize,
                  fontFamily: styles?.[1]?.fontFamily,
                }}
              >
                {contentDetails?.[0].company_name}
              </span>
            </div>
            <div className="right-top-image">
              <div className="dots">
                {Array.from({ length: 12 }).map(() => (
                  <div key={Math.random()} className="dot" />
                ))}
              </div>
            </div>
            <div className="content">
              <div className="circle_content">
                <div className="circle" />
              </div>
              <div className="profile">
                <div className="sceond-small-circle">
                  <div className="small_circle" />
                </div>
                <div className="personal-image">
                  <img
                    src={contentDetails?.[0].image}
                    alt="person_name"
                  />
                  <span className="persone-name"
                    style={{
                    color: styles?.[0]?.color,
                    fontSize: styles?.[0]?.fontSize,
                    fontFamily: styles?.[0]?.fontFamily,
                    }}
                  >
                    {contentDetails?.[0].name}</span>
                </div>
                <div className="small-circle">
                  <img
                    src={backgroundImage?.[1]}
                    alt="small-circle"
                  />
                </div>
              </div>
              <div className="content-text">
                <div className="anniversary">
                  <div className="content">
                    <div className="number"
                      style={{
                        fontSize: styles?.[2]?.fontSize,
                        color: styles?.[2]?.color,
                      }}>
                      {contentDetails?.[0].heading}<sup>st</sup>
                    </div>

                    <div className="work">work</div>
                  </div>
                  <div className="title">Anniversary</div>
                </div>
                <span
                  className="content-description"
                  style={{
                    color: `${styles?.[1]?.color}`,
                    fontFamily: `${styles?.[1]?.fontFamily}`,
                  }}
                >
                  {contentDetails?.[0]?.description}
                </span>
              </div>
            </div>
            <div className="left-bottom-image">
              <div className="dots">
                {Array.from({ length: 12 }).map(() => (
                  <div key={Math.random()} className="dot" />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

HtmlTemplateTwentyTwo.propTypes = {
  templateData: PropTypes.shape({
    id: PropTypes.string.isRequired,
    template_title: PropTypes.string.isRequired,
  }).isRequired,
  // Ensure templateData is an array of objects with specific shape
};

export default HtmlTemplateTwentyTwo;
